import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, TouchableOpacity } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import ChevronRight from '@/assets/icons/chevronRight';
import { LineSeparator } from '@/components/LineSeparator';
import { Screen } from '@/components/ScreenComponent';
import { ScreenNavBar } from '@/components/ScreenNavBar';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';

const REFERRAL_HISTORY = [
    {
        from: 'Max',
        awardedOn: '10/30/24',
        sentTo: 'Alex C.',
        amount: '25',
        status: 'settled',
    },
    {
        from: 'Jane',
        awardedOn: '10/30/24',
        sentTo: 'Alex C.',
        amount: '25',
        status: 'expired',
    },
];

const styles = StyleSheet.create({
    amount: {
        paddingLeft: 4,
    },
    referralItem: {
        paddingHorizontal: 16,
    },
});

//TODO: Referral history screen do not render referrals in progress, only settled and expired. Filter out when getting data from API
export const ReferralHistoryScreen = () => {
    const navigation = useNavigation();
    const { t } = useTranslation('raf');

    //TODO: remove any and set type for item
    const handleOnPress = (item: any) => {
        navigation.navigate('ReferralTracking', { referral: item });
    };

    return (
        <Screen>
            <ScreenNavBar title={t('referral_history')} />
            <MaxWidthWrapper>
                {REFERRAL_HISTORY.length === 0 ? (
                    <Box flex={1} alignItems={'center'} justifyContent={'center'} paddingHorizontal={'s40'}>
                        <Text variant="titleLarge">{t('no_referral_history')}</Text>
                        <Text variant="bodyMedium" color={ds.colorToken.text.secondary} textAlign={'center'}>
                            {/*TODO: request and change this text*/}A blurb about referral history will go here a blurb
                            about referral history will go here.
                        </Text>
                    </Box>
                ) : (
                    REFERRAL_HISTORY.map((item, index) => {
                        const referralSettled = item.status === 'settled';
                        const referralStatusText = referralSettled ? t('completed_on') : t('expired_on');
                        return (
                            <TouchableOpacity
                                onPress={() => handleOnPress(item)}
                                style={styles.referralItem}
                                key={`${item.sentTo}-${index}`}
                                activeOpacity={0.8}
                            >
                                <Box paddingVertical={'s16'}>
                                    <Row justifyContent={'space-between'} alignItems={'center'}>
                                        <Box>
                                            <Text variant={'bodyMedium'}>{`${t('sent_to')} ${item.sentTo}`}</Text>
                                            <Text
                                                variant={'bodySmall'}
                                                color={
                                                    referralSettled
                                                        ? ds.colorToken.text.secondary
                                                        : ds.colorToken.text.danger
                                                }
                                            >
                                                {referralStatusText} {item.awardedOn}
                                            </Text>
                                        </Box>
                                        <Row alignItems={'center'}>
                                            {referralSettled ? (
                                                <Box
                                                    width={8}
                                                    height={8}
                                                    borderRadius={'r10'}
                                                    backgroundColor={ds.colorToken.background.brand.emphasis}
                                                    marginHorizontal={'s16'}
                                                />
                                            ) : null}
                                            <ChevronRight />
                                        </Row>
                                    </Row>
                                </Box>
                                <LineSeparator />
                            </TouchableOpacity>
                        );
                    })
                )}
            </MaxWidthWrapper>
        </Screen>
    );
};
